export type MathDisplayMode = 'inline' | 'block';
export type MathOutputFormat = 'html-and-mathml' | 'mathml';

export const MATH_RENDER_SELECTOR = '[data-math-render]';
export const MATH_BLOCK_RENDER_SELECTOR = '[data-math-render][data-math-display="block"]';
export const MATH_FIELD_UI_SELECTORS = ['math-field', '[data-ML]', '[class*="ML__"]'] as const;

export interface MathRenderRequest {
  expression: string;
  display?: MathDisplayMode;
  output?: MathOutputFormat;
  macros?: Readonly<Record<string, string>>;
}

export interface MathRenderSuccess {
  success: true;
  html: string;
  mode: 'strict' | 'lenient';
  error?: never;
}

export interface MathRenderFailure {
  success: false;
  error: string;
  html?: never;
  mode?: never;
}

export type MathRenderResult = MathRenderSuccess | MathRenderFailure;

export interface MathRenderer {
  render(request: MathRenderRequest): MathRenderResult;
}
